import type { RegistrationForm } from "./types";

const inputClass =
  "w-full h-10 px-3 border border-border bg-background text-sm focus:outline-none focus:border-primary transition-colors";
const selectClass = inputClass;
const labelClass = "text-micro block mb-2";

interface Props {
  form: RegistrationForm;
  update: (field: string, value: any) => void;
}

export default function RegStammdaten({ form, update }: Props) {
  return (
    <div className="space-y-8">
      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Betriebsdaten</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Betriebsname *</label>
            <input value={form.company_name} onChange={(e) => update("company_name", e.target.value)} placeholder="Ihr Handwerksbetrieb" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Unternehmensart</label>
            <select value={form.company_type} onChange={(e) => update("company_type", e.target.value)} className={selectClass}>
              <option value="">– Bitte wählen –</option>
              <option value="GmbH">GmbH</option>
              <option value="UG">UG (haftungsbeschränkt)</option>
              <option value="GmbH & Co. KG">GmbH & Co. KG</option>
              <option value="KG">KG</option>
              <option value="OHG">OHG</option>
              <option value="Einzelunternehmen">Einzelunternehmen</option>
              <option value="Meisterbetrieb">Meisterbetrieb</option>
              <option value="GbR">GbR</option>
              <option value="Sonstige">Sonstige</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>Rechtlicher Name</label>
            <input value={form.legal_name} onChange={(e) => update("legal_name", e.target.value)} placeholder="z.B. lt. Handelsregister" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Kontaktperson *</label>
            <input value={form.contact_name} onChange={(e) => update("contact_name", e.target.value)} placeholder="Ihr Name" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Rolle / Position</label>
            <input value={form.contact_role} onChange={(e) => update("contact_role", e.target.value)} placeholder="z.B. Meister, Geschäftsführer" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>E-Mail *</label>
            <input type="email" value={form.contact_email} onChange={(e) => update("contact_email", e.target.value)} placeholder="ihre@email.de" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Telefon</label>
            <input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+49 ..." className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Website</label>
            <input value={form.website} onChange={(e) => update("website", e.target.value)} placeholder="https://..." className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Rechnungs-E-Mail</label>
            <input type="email" value={form.invoice_email} onChange={(e) => update("invoice_email", e.target.value)} placeholder="buchhaltung@betrieb.de" className={inputClass} />
          </div>
        </div>
      </section>

      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Adresse</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2">
            <label className={labelClass}>Straße & Hausnummer</label>
            <input value={form.address_line1} onChange={(e) => update("address_line1", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>PLZ</label>
            <input value={form.postal_code} onChange={(e) => update("postal_code", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Stadt</label>
            <input value={form.city} onChange={(e) => update("city", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Land</label>
            <select value={form.country} onChange={(e) => update("country", e.target.value)} className={selectClass}>
              <option value="DE">Deutschland</option>
              <option value="AT">Österreich</option>
              <option value="CH">Schweiz</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>USt-IdNr.</label>
            <input value={form.vat_id} onChange={(e) => update("vat_id", e.target.value)} placeholder="DE123456789" className={inputClass} />
          </div>
        </div>
      </section>
    </div>
  );
}
